import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import {
	AutoCompleteItem as DropdownAutoCompleteItem,
	Dropdown,
} from "@/components/Dropdown/Dropdown";
import { Information } from "@/components/Information/Information";

import {
	HubspotSyncTriggerWithInherit,
	ListSyncTriggerResponse,
} from "../../../../Company/schema/hubspot";

interface HubspotSyncSectionProps {
	isHubspotEnabled: boolean;
	isConnected: boolean;
	listSyncTrigger: ListSyncTriggerResponse | undefined;
	selectedHubspotSyncTrigger: HubspotSyncTriggerWithInherit | undefined;
	setSelectedHubspotSyncTrigger: (trigger: HubspotSyncTriggerWithInherit) => void;
}

export const HubspotSyncSection: FunctionComponent<HubspotSyncSectionProps> = ({
	isHubspotEnabled,
	isConnected,
	listSyncTrigger,
	selectedHubspotSyncTrigger,
	setSelectedHubspotSyncTrigger,
}) => {
	const { t } = useTranslation();
	const tsSettings = (key: string) => t(`list.settings.${key}`);

	if (!isHubspotEnabled || !isConnected) {
		return null;
	}

	return (
		<div className="flex flex-col w-full mt-8">
			<div className="flex flex-col gap-2 w-full mb-4">
				<div className="text-ssm font-medium text-text">
					{tsSettings("hubspot.syncTrigger.title")}{" "}
					<Information information={tsSettings("hubspot.syncTrigger.description")} />
				</div>
			</div>
			<Dropdown
				data={[
					{
						title: tsSettings("hubspot.syncTrigger.INHERIT"),
						id: HubspotSyncTriggerWithInherit.INHERIT,
					},
					{
						title: tsSettings("hubspot.syncTrigger.DISABLED"),
						id: HubspotSyncTriggerWithInherit.DISABLED,
					},
					{
						title: tsSettings("hubspot.syncTrigger.ON_CAMPAIGN_START"),
						id: HubspotSyncTriggerWithInherit.ON_CAMPAIGN_START,
					},
					{
						title: tsSettings("hubspot.syncTrigger.ON_REPLY"),
						id: HubspotSyncTriggerWithInherit.ON_REPLY,
					},
				]}
				defaultValue={
					selectedHubspotSyncTrigger
						? {
								id: selectedHubspotSyncTrigger,
								title: tsSettings(`hubspot.syncTrigger.${selectedHubspotSyncTrigger}`),
							}
						: undefined
				}
				floating={true}
				handleSelect={(value: DropdownAutoCompleteItem) => {
					setSelectedHubspotSyncTrigger(value.id as HubspotSyncTriggerWithInherit);
				}}
			/>
			{listSyncTrigger?.isInherited && (
				<div className="text-ssm text-text-meta mt-2">
					{tsSettings("hubspot.syncTrigger.inheritedFrom")}:{" "}
					{tsSettings(`hubspot.syncTrigger.${listSyncTrigger.effectiveTrigger}`)}
				</div>
			)}
		</div>
	);
};
